/**
 * Centralised ToolTipID constants.
 *
 * Each constant matches the ToolTipID column of a row in the SharePoint
 * Tooltips list.  Admins edit the TooltipDescription of those rows through
 * Settings → Metadata Management → Tooltips; the descriptions are then served
 * live throughout the application via `useTooltipResolver`.
 *
 * Naming convention: <SECTION>_<FIELD>
 */

// ─── Create / Edit Requirement Form ──────────────────────────────────────────
export const TT_FORM_TITLE           = 'Title'
export const TT_FORM_FISCAL_YEAR     = 'Fiscal Year'
export const TT_FORM_DIVISION        = 'Division'
export const TT_FORM_BRANCH          = 'Branch'
export const TT_FORM_CATEGORY        = 'Category'
export const TT_FORM_DESCRIPTION     = 'Description'
export const TT_FORM_AGREE_TERMS     = 'Agree to Terms'
export const TT_FORM_START_DATE      = 'Start Date'
export const TT_FORM_PRIORITY        = 'Priority'
export const TT_FORM_IS_ACTIVE       = 'Is Active'
export const TT_FORM_ATTACHMENTS             = 'Attach File(s)'
export const TT_FORM_PRODUCT                 = 'Product'
export const TT_FORM_TBM                     = 'TBM'
export const TT_FORM_NEED_BY_DATE            = 'Need by Date'
export const TT_FORM_ESTIMATED_COST          = 'Estimated Current Year Cost'
export const TT_FORM_ITAR_NUMBER             = 'ITAR Number'
export const TT_FORM_BASE_START_DATE         = 'Base Year Start Date'
export const TT_FORM_BASE_END_DATE           = 'Base Year End Date'
export const TT_FORM_BASE_COST               = 'Base Year Cost'
export const TT_FORM_REQUESTED_POP           = 'Requested PoP'
export const TT_FORM_REQUESTOR_PHONE         = 'Requestor Phone Number'
export const TT_FORM_POC_NAME                = 'POC Name'
export const TT_FORM_POC_PHONE               = 'POC Phone Number'
export const TT_FORM_OTHER_NAME              = 'Other Name'
export const TT_FORM_OTHER_ROLE              = 'Other Role'
export const TT_FORM_OTHER_PHONE             = 'Other Phone Number'
export const TT_FORM_CTR_SUPPORT_REQUIRED    = 'CTR Support Required'
export const TT_FORM_CTR_VENDOR              = 'CTR Vendor'
export const TT_FORM_CTR_SUPPORT             = 'Describe CTR Support'
export const TT_FORM_REQUIREMENT_DESCRIPTION = 'Requirement Description'
export const TT_FORM_IMPACT_STATEMENT        = 'Impact Statement'
export const TT_FORM_LEVEL_OF_URGENCY        = 'Level of Urgency'
export const TT_FORM_SCOPE_OF_WORK           = 'Scope of Work'
export const TT_FORM_OTHER_BRANCHES          = 'Other Branches'
export const TT_FORM_SOLE_SOURCE_REQUIRED    = 'Sole Source Required'
export const TT_FORM_REQUESTED_VENDOR        = 'Requested Vendor'
export const TT_FORM_SOLE_SOURCE_JUSTIFICATION = 'Sole Source Justification'
export const TT_FORM_BRAND_NAME_REQUIRED     = 'Brand Name Required'
export const TT_FORM_REQUESTED_PRODUCT       = 'Requested Product'
export const TT_FORM_BRAND_NAME_JUSTIFICATION = 'Brand Name Justification'
export const TT_FORM_JUSTIFICATION_DOCUMENT  = 'Justification Document'
export const TT_FORM_ACQUISITION_METHOD      = 'Acquisition Method'
export const TT_FORM_UFMS_TARGET_DATE        = 'UFMS Target Date'
export const TT_FORM_REQUISITION_NUMBER      = 'Requisition Number'
export const TT_FORM_BUDGET_REFERENCE        = 'Budget Reference'
export const TT_FORM_INVESTMENT              = 'Investment'
export const TT_FORM_CONTRACT_SPECIALIST     = 'Contract Specialist'
export const TT_FORM_AWARD_VENDOR            = 'Awarded Vendor'
export const TT_FORM_CONTRACT_START_DATE     = 'Contract Start Date'
export const TT_FORM_CONTRACT_END_DATE       = 'Contract End Date'
export const TT_FORM_HHS_AWARD_NUMBER        = 'HHS Award Number'
export const TT_FORM_OBJECT_CLASS            = 'Object Class'
export const TT_FORM_MASTER_OBJECT_CLASS     = 'Master Object Class'

// ─── Grant / Case Form ───────────────────────────────────────────────────────
export const TT_GRANT_CASE_TYPE            = 'CASE_CaseType'
export const TT_GRANT_PROGRAM_TYPE         = 'CASE_ProgramType'
export const TT_GRANT_FUNDING_SOURCE       = 'CASE_FundingSource'
export const TT_GRANT_IA                   = 'CASE_IA'
export const TT_GRANT_COUNTRY              = 'CASE_Country'
export const TT_GRANT_START_FY             = 'CASE_StartFiscalYear'
export const TT_GRANT_END_FY               = 'CASE_EndFiscalYear'
export const TT_GRANT_CASE_DESIGNATOR      = 'CASE_CaseDesignator'
export const TT_GRANT_USER_CASE_ID         = 'CASE_UserCaseID'
export const TT_GRANT_LINE_NUMBER          = 'CASE_Line'
export const TT_GRANT_REGIONAL_CENTER      = 'CASE_RegionalCenter'
export const TT_GRANT_DESCRIPTION          = 'CASE_Description'
export const TT_GRANT_ATTACHMENTS          = 'CASE_Attachments'

// ─── Training Form ───────────────────────────────────────────────────────────
export const TT_TRAINING_USER_CASE_ID        = 'TRAINING_UserCaseID'
export const TT_TRAINING_LINE              = 'TRAINING_Line'
export const TT_TRAINING_TYPE              = 'TRAINING_Type'
export const TT_TRAINING_WCN               = 'TRAINING_WCN'
export const TT_TRAINING_PRIORITY          = 'TRAINING_Priority'
export const TT_TRAINING_FISCAL_YEAR       = 'TRAINING_FiscalYear'
export const TT_TRAINING_QUARTER           = 'TRAINING_Quarter'
export const TT_TRAINING_RANK              = 'TRAINING_Rank'
export const TT_TRAINING_TPC               = 'TRAINING_TPC'
export const TT_TRAINING_STUDENT_FIRST_NAME  = 'TRAINING_TrainingPersonFirstName'
export const TT_TRAINING_STUDENT_MIDDLE_NAME = 'TRAINING_TrainingPersonMiddleName'
export const TT_TRAINING_STUDENT_LAST_NAME   = 'TRAINING_TrainingPersonLastName'
export const TT_TRAINING_VETTED            = 'TRAINING_Vetted'
export const TT_TRAINING_SUFFIX            = 'TRAINING_Suffix'
export const TT_TRAINING_TMASL             = 'TRAINING_T-MASL'
export const TT_TRAINING_LOCATION          = 'TRAINING_Location'
export const TT_TRAINING_EXA               = 'TRAINING_EXA'
export const TT_TRAINING_REPORT_DATE       = 'TRAINING_ReportDate'
export const TT_TRAINING_END_DATE          = 'TRAINING_EndDate'
export const TT_TRAINING_DURATION          = 'TRAINING_Duration'
export const TT_TRAINING_DURATION_TYPE     = 'TRAINING_DurationType'
export const TT_TRAINING_CLASS_ID          = 'TRAINING_ClassID'
export const TT_TRAINING_STATUS            = 'TRAINING_Status'
export const TT_TRAINING_FINANCIAL_STATUS  = 'TRAINING_FinancialStatus'
export const TT_TRAINING_FACILITY          = 'TRAINING_FacilityCategory'
export const TT_TRAINING_DESCRIPTION       = 'TRAINING_Description'
export const TT_TRAINING_ATTACHMENTS       = 'TRAINING_Attachments'

// ─── Shared / Common ─────────────────────────────────────────────────────────
export const TT_COMMON_IS_ARCHIVED   = 'Is Archived'
export const TT_COMMON_ATTACHMENTS   = 'Attach File(s)'

// ─── Announcements ───────────────────────────────────────────────────────────
export const TT_ANN_TITLE            = 'Title'
export const TT_ANN_DESCRIPTION      = 'Description'
export const TT_ANN_TAGS             = 'Tags'
export const TT_ANN_EXPIRY_DATE      = 'Expiry Date'

// ─── Knowledge Base ─────────────────────────────────────────────────────────
export const TT_KG_TITLE             = 'Title'
export const TT_KG_DESCRIPTION       = 'Description'
export const TT_KG_TAGS              = 'Tags'

// ─── Q&A ───────────────────────────────────────────────────────────────────
export const TT_QA_QUESTION          = 'Question'
export const TT_QA_DESCRIPTION       = 'Description'
export const TT_QA_ANSWER            = 'Answer'
export const TT_QA_TAGS              = 'Tags'

// ─── Points of Contact ───────────────────────────────────────────────────────
export const TT_POC_NAME             = 'Name'
export const TT_POC_TITLE            = 'Title'
export const TT_POC_EMAIL            = 'Email'
export const TT_POC_PHONE            = 'Phone'

// ─── Quick Links ─────────────────────────────────────────────────────────────
export const TT_QL_TITLE             = 'Title'
export const TT_QL_URL               = 'URL'
export const TT_QL_INFO              = 'Info'

// ─── Release Notes ───────────────────────────────────────────────────────────
export const TT_RN_VERSION_NAME      = 'Version Name'
export const TT_RN_RELEASE_DATE      = 'Release Date'
export const TT_RN_NEW_FEATURES      = 'New Features'
export const TT_RN_RESOLVED_ISSUES   = 'Resolved Issues'
export const TT_RN_KNOWN_ISSUES      = 'Known Issues'

// ─── Tooltip Metadata Management ─────────────────────────────────────────────
export const TT_TT_TOOLTIP_ID        = 'Tooltip ID'
export const TT_TT_LABEL_NAME        = 'Tooltip Label'
export const TT_TT_DESCRIPTION       = 'Tooltip Description'

/**
 * Default fallback descriptions keyed by the same ToolTipID strings used in
 * the SharePoint ToolTipList.  These show when AppConfig has not yet been run
 * or a particular entry is missing from the list.
 */
export const TOOLTIP_DEFAULTS: Record<string, string> = {
    // Shared field labels (one entry per unique ToolTipID — matches SharePoint ToolTipList)
    'Title':               'Enter a concise title for this item.',
    'Description':         'Provide a detailed description.',
    'Attach File(s)':      'Upload supporting files (PDF, DOCX, XLSX, PNG, JPEG). Max 25 MB per file, up to 10 files.',
    'Tags':                'Add comma-separated tags to help categorise this item.',
    'Expiry Date':         'Set the date after which this item will no longer be displayed.',
    'Is Archived':         'Indicates whether this item has been archived and is no longer active.',
    'Name':                'Full name of the point of contact.',
    'Email':               'Official email address for this contact.',
    'Phone':               'Phone number for this contact (optional).',
    'URL':                 'Enter the full URL including https://.',
    'Info':                'Optionally provide a brief description.',
    // Q&A
    'Question':            'Enter the question being addressed.',
    'Answer':              'Enter the official answer or response to the question.',
    // Release Notes
    'Version Name':        'Enter the version identifier, e.g. v1.2.0.',
    'Release Date':        'Select the date this version was or will be released.',
    'New Features':        'Describe the new features included in this release.',
    'Resolved Issues':     'List the issues or bugs resolved in this release.',
    'Known Issues':        'Document any known issues that remain unresolved in this release.',
    // Tooltip Metadata
    'Tooltip ID':          'The unique identifier that links this tooltip to a specific field in the application.',
    'Tooltip Label':       'The field label this tooltip is associated with.',
    'Tooltip Description': 'The tooltip text displayed to users when they hover over or focus the associated field.',
    // Requirement Form — section-specific fields
    'Fiscal Year':         'Select the fiscal year this requirement applies to.',
    'Division':            'Select the division responsible for this requirement.',
    'Branch':              'Select the branch within the selected division.',
    'Category':            'Choose the category that best describes this requirement.',
    'Agree to Terms':      'Check this box to confirm you have read and agree to the terms.',
    'Start Date':          'Select the anticipated start date for this requirement.',
    'Priority':            'Select the priority level: High, Medium, or Low.',
    'Is Active':           'Toggle to indicate whether this requirement is currently active.',
    // Requirement Form — extended fields
    'Product':                         'Select the product associated with this requirement.',
    'TBM':                             'Select the Technology Business Management category.',
    'Need by Date':                    'Select the date by which this requirement is needed.',
    'Estimated Current Year Cost':     'Enter the estimated cost for the current fiscal year.',
    'ITAR Number':                     'Enter the ITAR number if applicable to this requirement.',
    'Base Year Start Date':            'Select the start date for the base year period of performance.',
    'Base Year End Date':              'Select the end date for the base year period of performance.',
    'Base Year Cost':                  'Enter the estimated cost for the base year.',
    'Requested PoP':                   'Indicate the requested period of performance.',
    'Requestor Phone Number':          'Enter the phone number of the requestor.',
    'POC Name':                        'Enter the name of the primary point of contact.',
    'POC Phone Number':                'Enter the phone number of the primary point of contact.',
    'Other Name':                      'Enter the name of an additional point of contact.',
    'Other Role':                      'Enter the role of the additional point of contact.',
    'Other Phone Number':              'Enter the phone number of the additional point of contact.',
    'CTR Support Required':            'Indicate whether specific contractor support is required.',
    'CTR Vendor':                      'Select the contractor vendor that will support this request.',
    'Describe CTR Support':            'Describe the contractor support needed for this requirement.',
    'Requirement Description':         'Provide a detailed description of the requirement.',
    'Impact Statement':                'Describe the impact if this requirement is not fulfilled.',
    'Level of Urgency':                'Describe the urgency level and justification for this requirement.',
    'Scope of Work':                   'Define the scope of work for this requirement.',
    'Other Branches':                  'Select other branches that leverage or are impacted by this tool.',
    'Sole Source Required':            'Indicate whether this request requires a specific vendor (sole source).',
    'Requested Vendor':                'Identify the specific vendor being requested.',
    'Sole Source Justification':       'Describe why a sole source vendor is required for this acquisition.',
    'Brand Name Required':             'Indicate whether this request requires a specific product brand.',
    'Requested Product':               'Identify the specific product being requested.',
    'Brand Name Justification':        'Describe why a specific brand name product is required.',
    'Justification Document':          'Upload the supporting justification document.',
    'Acquisition Method':              'Select the acquisition method for this requirement.',
    'UFMS Target Date':                'Select the target date for UFMS processing.',
    'Requisition Number':              'Enter the requisition number if already assigned.',
    'Budget Reference':                'Select the budget reference associated with this acquisition.',
    'Investment':                      'Select the investment category for this acquisition.',
    'Contract Specialist':             'Enter the name of the assigned contract specialist.',
    'Awarded Vendor':                  'Select the vendor that was awarded the contract.',
    'Contract Start Date':             'Select the start date of the contract.',
    'Contract End Date':               'Select the end date of the contract.',
    'HHS Award Number':                'Enter the HHS award number for this contract.',
    'Object Class':                    'Select the object class for budget classification.',
    'Master Object Class':             'Select the master object class for budget classification.',
    // Grant / Case Form
    'Case Type':                       'Select the type of case (e.g., Grants).',
    'Program Type':                    'Select the program type for this case.',
    'Funding Source':                  'Select the funding source; auto-filled based on program type.',
    'Implementing Agency':             'Select the implementing agency responsible for this case.',
    'Country':                         'Select the country associated with this case.',
    'Start Fiscal Year':               'Select the fiscal year in which this case begins.',
    'End Fiscal Year':                 'Select the fiscal year in which this case ends.',
    'Case Designator':                 'Auto-generated case designator based on fiscal year and program type.',
    'User Case ID':                    'Auto-generated unique identifier for this case.',
    'Line Number':                     'Enter a unique line number for this case line.',
    'Regional Center':                 'Select the regional center associated with this case line.',
    'Attachments':                     'Upload supporting documents (PDF, DOCX, XLSX, PNG, JPEG). Max 25 MB per file.',
    // Training Form
    'Training Line':                   'Select the case line associated with this training.',
    'Training Type':                   'Select the type of training to be conducted.',
    'WCN':                             'Select the Weapons Case Number for this training request.',
    'Quarter':                         'Select the fiscal quarter for this training.',
    'Rank':                            'Select the rank of the training participant.',
    'TPC':                             'Enter the Training Program Coordinator name.',
    'Training Person First Name':      'Enter the first name of the training participant.',
    'Training Person Middle Name':     'Enter the middle name of the training participant (optional).',
    'Training Person Last Name':       'Enter the last name of the training participant.',
    'Vetted':                          'Indicate whether the training participant has been vetted.',
    'Suffix':                          'Select the course suffix for this training track.',
    'T-MASL':                          'Enter the T-MASL identifier for this training track.',
    'Location':                        'Enter the training location.',
    'EXA':                             'Select the EXA for this training track.',
    'Report Date':                     'Select the date this training was or will be reported.',
    'Training End Date':               'Select the end date for this training track.',
    'Duration':                        'Enter the duration of the training.',
    'Duration Type':                   'Select the unit of duration (Days or Weeks).',
    'Class ID':                        'Enter the class identifier for this training track.',
    'Training Status':                 'Select the enrollment status for this training.',
    'Financial Status':                'Select the financial status for this training.',
    'Facility Category':               'Select the facility category for this training.',
}
